module.exports = __webpack_public_path__ + "media/images/Technology_Services_logo_rgb_reverse-8d27880296670527c51a0b002be1c4ea.png";